import { createAction, UnknownAction } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse, Method, ResponseType } from "axios";

interface BaseHeaders {
  Authorization?: string;
  "Accept-Language"?: string;
  "Content-Type"?: string;
}

interface Headers extends BaseHeaders {
  [key: string]: string | undefined;
}

interface Resp {
  data: any;
}

export interface ApiCallBeganPayload {
  url: string;
  method: Method;
  data?: any;
  onStart?: string;
  onSuccess?: string;
  onError?: string;
  headers: Headers;
  responseType?: ResponseType;
  extraData?: any;
}

export interface ApiCallSuccessPayload {
  data: any;
  extraData?: any;
}

export interface ApiCallFailedPayload {
  code: number;
  message: string;
  extraData?: any;
}

export const apiCallBegan = createAction<ApiCallBeganPayload>('api/callBegan');
export const apiCallSuccess = createAction<ApiCallSuccessPayload>('api/callSuccess');
export const apiCallFailed = createAction<ApiCallFailedPayload>('api/callFailed');

export type SuccessResponse = AxiosResponse<Resp>;
export type ErrorResponse = AxiosError;

export function isSuccessResponse(response: SuccessResponse | ErrorResponse | UnknownAction): response is SuccessResponse {
  return (response as SuccessResponse).data !== undefined && response.status === 200;
}

export function isErrorResponse(response: SuccessResponse | ErrorResponse | UnknownAction | undefined): response is ErrorResponse {
  return response !== undefined && 'status' in response && typeof response.status === 'number' && response.status > 299;
}